import MoodyReportPopup from './MoodyReportPopup';

export default MoodyReportPopup;
